import _ from 'lodash'

const key = 'condition.termTwo.condition.termOne.condition.comparison'

export default ({ formikProps: { values } }) => _.get(values, key) === 'and'
